<fieldset>
  <div class="column-100">
      <gmt-input label="Datum úhrady zálohy na náhradu" required="true">
        <input type="text" pick-a-date [(ngModel)]="data.expropriationCompensationPaymentDate" [maxToday]="true"/>
      </gmt-input>
  </div>
</fieldset>
